<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      v-b-modal.form-employee-movement-modal
      @click="cleanUpForm()"
    >
      Tambah
    </b-button>

    <b-modal
      id="form-employee-movement-modal"
      no-close-on-backdrop
      size="lg"
      :title="(editId == null ? 'Tambah' : 'Edit') + ' Pengajuan Mutasi'"
    >
      <validation-observer ref="employeeMovementValidation">
        <div class="form">
          <div class="row">
            <div class="col-7">

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Nama Karyawan</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="employeeId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Karyawan --"
                        v-model="formPayloadEmployeeMovement.employeeId"
                        :options="employeeList"
                        :reduce="employee => employee.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Grade</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="gradeId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Grade --"
                        v-model="formPayloadEmployeeMovement.gradeId"
                        :options="gradeList"
                        :reduce="grade => grade.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Cabang</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="branchId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Cabang --"
                        v-model="formPayloadEmployeeMovement.branchId"
                        :options="branchList"
                        :reduce="branch => branch.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Departement</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="departmentCode"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Departement --"
                        v-model="formPayloadEmployeeMovement.departmentCode"
                        :options="departmentList"
                        :reduce="department => department.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Band</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="bandId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Band --"
                        v-model="formPayloadEmployeeMovement.bandId"
                        :options="bandList"
                        :reduce="band => band.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Job Title</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="jobTitleId"
                    rules="required"
                  >
                    <v-select size="sm" 
                        placeholder="-- Pilih Job Title --"
                        v-model="formPayloadEmployeeMovement.jobTitleId"
                        :options="jobTitleList"
                        :reduce="jobTitle => jobTitle.value"
                        label="text"
                     />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Alasan Dipindah</label>
                <div class="col-sm-8">
                  <validation-provider
                    #default="{ errors }"
                    name="note"
                    rules="required"
                  >
                    <b-form-input
                      v-model="formPayloadEmployeeMovement.note"
                      :state="validations.note ? false : null"
                      placeholder=""
                    />
                     <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>

            </div>
          </div>
        </div>
      </validation-observer>

      <template #modal-footer="{}">
        <div v-if="isLoadingBand">
          <br />
          <b-spinner class="mb-2" variant="primary" /><br />
        </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          :disabled="isLoadingBand"
          @click="submitItem()"
        >
          Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";
import vSelect from "vue-select";

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
  },
  directives: {
    Ripple,
  },
  /* eslint-disable vue/require-default-prop */
  props: {
    formPayload: {
      type: "",
    },
    isLoading: {
      type: Boolean,
    },
    editId: {
      type: String,
    },
    createItem: {
      type: Function,
    },
    updateItem: {
      type: Function,
    },
    validations: {
      type: "",
    },
    cleanUpForm: {
      type: Function,
    },
    employee: {
      type: "",
    },
    branch: {
      type: "",
    },
    department: {
      type: "",
    },
    band: {
      type: "",
    },
    jobTitle: {
      type: "",
    },
    grade: {
      type: "",
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      parents: [],
      isLoadingBand: false,
      formPayloadEmployeeMovement: {
        bandId: 0,
        branchId: 0,
        departmentCode: "",
        employeeId: 0,
        gradeId: 0,
        jobTitleId: 0,
        movementCategory: 0,
        note: ""
      },
      employeeList: [],
      branchList: [],
      departmentList: [],
      bandList: [],
      jobTitleList: []
    };
  },
  watch: {
    isLoading(value) {
      this.isLoadingBand = value;
    },
    formPayload: {
      handler(value) {
        this.formPayloadEmployeeMovement = value;
      },
      deep: true,
    },
    formPayloadEmployeeMovement: {
      handler(value) {
        this.$emit("payloadBandisLoadingBand", value);
      },
      deep: true,
    },
    employee(value) {
      this.employeeList = value;
    },
    branch(value) {
      this.branchList = value;
    },
    department(value) {
      this.departmentList = value;
    },
    band(value) {
      this.bandList = value;
    },
    jobTitle(value) {
      this.jobTitleList = value;
    },
    grade(value) {
      this.gradeList = value;
    },
  },
  methods: {
    submitItem() {
      this.$refs.employeeMovementValidation.validate().then((success) => {
        if (success) {
          if (this.editId == null) {
            this.createItem();
          } else {
            this.updateItem();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
